import { forwardRef } from 'react';
import type { LucideProps } from 'lucide-react';

export const WordIcon = forwardRef<SVGSVGElement, LucideProps>(function WordIcon({ color = 'currentColor', size = 24, strokeWidth: _strokeWidth, ...props }, ref) {
  return (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <rect x="2" y="2" width="20" height="20" rx="4" fill={color} />
      <path d="M5.1 7.1h2.4l1.45 7.02L10.6 7.1h2.7l1.62 7.02 1.48-7.02h2.4l-2.55 9.8h-2.63l-1.7-6.94-1.72 6.94H7.64L5.1 7.1Z" fill="white" />
    </svg>
  );
});

export const ExcelIcon = forwardRef<SVGSVGElement, LucideProps>(function ExcelIcon({ color = 'currentColor', size = 24, strokeWidth: _strokeWidth, ...props }, ref) {
  return (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <rect x="2" y="2" width="20" height="20" rx="4" fill={color} />
      <path d="m6.1 7.1 4.05 4.72-4.33 5.08h3.05l2.82-3.38 2.86 3.38h3.14l-4.38-5.13 4.02-4.67h-3.04l-2.58 3.05-2.56-3.05H6.1Z" fill="white" />
    </svg>
  );
});

export const PowerPointIcon = forwardRef<SVGSVGElement, LucideProps>(function PowerPointIcon({ color = 'currentColor', size = 24, strokeWidth: _strokeWidth, ...props }, ref) {
  return (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <rect x="2" y="2" width="20" height="20" rx="4" fill={color} />
      <path d="M7 6.8h5.35c3.1 0 4.75 1.5 4.75 4.1 0 2.72-1.85 4.25-4.95 4.25h-2.3V18H7V6.8Zm2.85 2.35v3.65h2.08c1.46 0 2.3-.62 2.3-1.83 0-1.22-.84-1.82-2.3-1.82H9.85Z" fill="white" />
    </svg>
  );
});
